import type { ReactNode } from 'react';

import { COMPETITION_PAGE_BG } from './competitionBranding';
import { PublicFooter } from './Footer';
import { PublicHeader } from './Header';
import { OrganizerLogoBar } from './OrganizerLogoBar';

interface PublicPageShellProps {
  children: ReactNode;
  /** Extra classes applied to the <main> element */
  mainClassName?: string;
  /** When true the root div fills exactly one viewport height with no overflow (poczekalnia) */
  fitViewport?: boolean;
}

export const PublicPageShell = ({
  children,
  mainClassName = '',
  fitViewport = false,
}: PublicPageShellProps) => (
  <div
    className={`font-rounded flex flex-col ${fitViewport ? 'h-dvh overflow-hidden' : 'min-h-dvh'}`}
    style={{ background: COMPETITION_PAGE_BG }}
  >
    <PublicHeader />
    <OrganizerLogoBar />
    <main className={`flex flex-1 flex-col ${fitViewport ? 'min-h-0 overflow-y-auto md:overflow-hidden' : ''} ${mainClassName}`}>
      {children}
    </main>
    <PublicFooter />
  </div>
);
